import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { RegionBlock } from './components/RegionBlock';
import { Explore } from './pages/Explore';
import { Home } from './pages/Home';
import { DropDetail } from './pages/DropDetail';
import { OriginalDetail } from './pages/OriginalDetail';
import { ContentDetail } from './pages/ContentDetail';
import { ChannelPage } from './pages/ChannelPage';
import { CreatorProfile } from './pages/CreatorProfile';
import { Channels } from './pages/Channels';
import { Drops } from './pages/Drops';
import { checkRegionBlocked } from './lib/geo';

function App() {
  // 'pending' until the region check resolves — render nothing so a blocked
  // visitor never sees the app flash before the gate.
  const [region, setRegion] = useState<'pending' | 'blocked' | 'allowed'>('pending');

  useEffect(() => {
    checkRegionBlocked().then((blocked) => setRegion(blocked ? 'blocked' : 'allowed'));
  }, []);

  if (region === 'pending') return null;
  if (region === 'blocked') return <RegionBlock />;

  return (
    <div className="min-h-screen bg-provny-white text-provny-black dark:bg-provny-ink dark:text-provny-white">
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/explore" replace />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/home" element={<Home />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/drops" element={<Drops />} />
        <Route path="/drop/:id" element={<DropDetail />} />
        <Route path="/original/:id" element={<OriginalDetail />} />
        <Route path="/p/:id" element={<ContentDetail />} />
        <Route path="/c/:slug" element={<ChannelPage />} />
        {/* Root-level dynamic segment — matches /@handle. v7 ranks static
            segments above this, so /explore etc. win regardless of order;
            kept last by convention. */}
        <Route path="/:handle" element={<CreatorProfile />} />
      </Routes>
    </div>
  );
}

export default App;
